import { RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type ICardRepository } from '@webapp/modules/spending-cards/business-logic/interfaces/ICardRepository'
import { SpendingCardUseCaseErrors } from '@webapp/modules/spending-cards/business-logic/use-cases/SpendingCardUseCaseErrors'

const CANNOT_ACTIVATE_STRIPE_CARD_ERROR_CODE = 'CANT_ACTIVATE_STRIPE_CARD'

export class ActivatePhysicalCardUseCase {
  constructor(
    private readonly deps: {
      cardRepository: ICardRepository
    }
  ) {}

  execute = async ({ externalId }: { externalId: string }) => {
    try {
      await this.deps.cardRepository.activateCard(externalId)
    } catch (err) {
      if (err instanceof RepoError) {
        if (err.code === CANNOT_ACTIVATE_STRIPE_CARD_ERROR_CODE) {
          throw new SpendingCardUseCaseErrors({
            name: 'ERROR_ACTIVATING_STRIPE_PHYSICAL_CARD',
            message: 'Cannot activate Stripe physical card',
          })
        } else if (err.code) {
          // Pass in the message from the RepoError when backend provided error code
          throw new SpendingCardUseCaseErrors({
            name: 'ERROR_ACTIVATING_PHYSICAL_CARD',
            message: err.message,
          })
        }
      }

      throw new SpendingCardUseCaseErrors({
        name: 'GENERAL_ERROR_ACTIVATING_PHYSICAL_CARD',
        message: 'Error activating physical card',
      })
    }
  }
}
